<template>
    <div class="mb-4">
        <b-row>
            <b-col md="8">
                <b-card>
                    <h4 class="strong">Downhole Sensor</h4>
                    <hr />
                    <b-row>
                        <b-col md="6">
                            <b-form-text>Uses Downhole Sensor?</b-form-text>
                            <b-form-select size="sm" v-model="input.isUsingDownholeSensor">
                                <option value=0>No</option>
                                <option value=1>Yes</option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card class="mt-4">
                    <b-row>
                        <b-col md="10">
                            <h4 class="strong">Gas Handler & Separator</h4>
                        </b-col>
                        <b-col md="2" style="text-align: end">
                            <b-badge 
                                v-if="prctFGIntoPump > freeGasIntoPumpLimit"
                                variant="danger" 
                                v-b-popover.hover.right="{ variant: 'danger', content: `Free Gas into Pump exceeds ${freeGasIntoPumpLimit}%!` }">
                                Warning
                            </b-badge>
                        </b-col>
                    </b-row>
                    <hr />
                    <b-row>
                        <b-col md="12">
                            <b-form-text>Free Gas Available</b-form-text>
                            <strong>{{ prctFGAvailable }}</strong> <span style="font-size: 10pt"> %</span>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col md="6">
                            <b-form-text>Gas Handler</b-form-text>
                            <b-form-select size="sm" v-model="input.gasHandler" :options="optHandler" />
                        </b-col>
                        <b-col md="6" v-if="input.gasHandler != 'None'">
                            <b-form-text>Gas Handler Efficiency</b-form-text>
                            <b-input-group size="sm" append="%">
                                <b-input size="sm" type="number" step="any" v-model="input.gasHandlerEff" />
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col md="6">
                            <b-form-text>Intake</b-form-text>
                            <b-form-select size="sm" v-model="input.gasSeparator" :options="optSeparator" />
                        </b-col>
                        <b-col md="6" v-if="!input.gasSeparator.startsWith('Standard')">
                            <b-form-text>Gas Separator Efficiency</b-form-text>
                            <b-input-group size="sm" append="%">
                                <b-input size="sm" type="number" step="any" v-model="input.gasSeparatorEff" />
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col md="6">
                            <b-form-text>% FG into Pump</b-form-text>
                            <b-input-group size="sm" append="%">
                                <b-input size="sm" type="number" step="any" readonly v-model="prctFGIntoPump" />
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card class="mt-4">
                    <h4 class="strong">Pump</h4>
                    <hr />
                    <b-row>
                        <b-col md="3">
                            <b-form-text>Selected Pump</b-form-text>
                            <strong>{{ selectedPump }}</strong>
                        </b-col>
                        <b-col md="3">
                            <b-form-text>Pump Type</b-form-text>
                            <strong>{{ pumpType }}</strong>
                        </b-col>
                        <b-col md="3">
                            <b-form-text>Stages Selected</b-form-text>
                            <strong>{{ stages }}</strong>
                        </b-col>
                        <b-col md="3">
                            <b-form-text>Design Frequency</b-form-text>
                            <strong>{{ frequency }}</strong> <span style="font-size: 10pt"> Hz</span>
                        </b-col>
                    </b-row>
                    <!-- <b-row class="mt-3">
                        <b-col md="6">
                            <b-form-text>Natural Separation Eff</b-form-text>
                            <b-input-group size="sm" append="%">
                                <b-input size="sm" type="number" step="any" v-model="input.naturalSeparationEff" />
                            </b-input-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-text>% FG into Pump</b-form-text>
                            <b-input-group size="sm" append="%">
                                <b-input size="sm" type="number" step="any" readonly v-model="prctFGIntoPump" />
                            </b-input-group>
                        </b-col>
                    </b-row> -->
                </b-card>
                <b-card class="mt-4">
                    <b-row>
                        <b-col md="10">
                            <h4 class="strong">Protectors & Motors</h4>
                        </b-col>
                        <b-col md="2" style="text-align: end">
                            <b-badge 
                                v-if="minMotorLoad > motorRatedHp"
                                variant="danger" 
                                v-b-popover.hover.right="{ variant: 'danger', content:'The selected motors\' HP is lower than Minimum Motor Load!' }">
                                Warning
                            </b-badge>
                        </b-col>
                    </b-row>
                    <hr />
                    <b-row>
                        <b-col md="4">
                            <b-form-text>Protector No. 1</b-form-text>
                            <b-form-select size="sm" v-model="input.protector1" :options="protectors" @change="didChangeFirstProtector" />
                        </b-col>
                        <b-col md="8">
                            <b-form-text>Motor No. 1</b-form-text>
                            <b-form-select v-if="input.protector1.endsWith('319s')" size="sm" v-model="input.motor1">
                                <option v-for="motor in motors319s" v-bind:key="motor[0]" v-bind:value="motor">
                                    {{ motor[4] }}, {{ motor[1] }} HP, {{ motor[2] }} V, {{ motor[3] }} A
                                </option>
                            </b-form-select>

                            <b-form-select v-else-if="input.protector1.endsWith('456s')" size="sm" v-model="input.motor1">
                                <option v-for="motor in motors456s" v-bind:key="motor[0]" v-bind:value="motor">
                                    {{ motor[4]}}, {{ motor[1] }} HP, {{ motor[2] }} V, {{ motor[3] }} A
                                </option>
                            </b-form-select>

                            <b-form-select v-else-if="input.protector1.endsWith('460s')" size="sm" v-model="input.motor1">
                                <option v-for="motor in motors460s" v-bind:key="motor[0]" v-bind:value="motor">
                                    {{ motor[4]}}, {{ motor[1] }} HP, {{ motor[2] }} V, {{ motor[3] }} A
                                </option>
                            </b-form-select>

                            <b-form-select v-else-if="input.protector1.endsWith('512s')" size="sm" v-model="input.motor1">
                                <option v-for="motor in motors512s" v-bind:key="motor[0]" v-bind:value="motor">
                                    PMM-512 PL200 3600 RPM, {{ motor[1] }} HP, {{ motor[2] }} V, {{ motor[3] }} A
                                </option>
                            </b-form-select>

                            <b-form-select v-else-if="input.protector1.endsWith('562s')" size="sm" v-model="input.motor1">
                                <option v-for="motor in motors562s" v-bind:key="motor[0]" v-bind:value="motor">
                                    PMM-562 PL200 3600 RPM, {{ motor[1] }} HP, {{ motor[2] }} V, {{ motor[3] }} A
                                </option>
                            </b-form-select>

                            <b-form-select v-else size="sm" v-model="input.motor1">
                                <option v-for="motor in motors540s" v-bind:key="motor[0]" v-bind:value="motor">
                                    540s, {{ motor[1] }} HP, {{ motor[2] }} V, {{ motor[3] }} A
                                </option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col md="4">
                            <b-form-text>Protector No. 2</b-form-text>
                            <b-form-select size="sm" v-model="input.protector2">
                                <option value="Do not use">Do not use</option>
                                <option v-for="protector in optProtectors2" v-bind:key="protector" v-bind:value="protector">
                                    {{ protector }}
                                </option>
                            </b-form-select>
                        </b-col>
                        <b-col md="8">
                            <b-form-text>Motor No. 2</b-form-text>
                            <b-form-select size="sm" v-model="input.motor2">
                                <option value=0>Do not use</option>
                                <option value=1>
                                    {{ input.motor1[4] }}, {{ input.motor1[1] }} HP, {{ input.motor1[2] }} V, {{ input.motor1[3] }} A
                                </option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="4">
                            <b-form-text>Protector No. 3</b-form-text>
                            <b-form-select size="sm" v-model="input.protector3">
                                <option value="Do not use">Do not use</option>
                                <option v-for="protector in optProtectors2" v-bind:key="protector" v-bind:value="protector">
                                    {{ protector }}
                                </option>
                            </b-form-select>
                        </b-col>
                        <b-col md="8">
                            <b-form-text>Motor No. 3</b-form-text>
                            <b-form-select size="sm" v-model="input.motor3">
                                <option value=0>Do not use</option>
                                <option value=1>
                                    {{ input.motor1[4] }}, {{ input.motor1[1] }} HP, {{ input.motor1[2] }} V, {{ input.motor1[3] }} A
                                </option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                   
                    <b-row class="mt-3">
                        <b-col md="4">
                            <b-form-text>Protector No. 4</b-form-text>
                            <b-form-select size="sm" v-model="input.protector4">
                                <option value="Do not use">Do not use</option>
                                <option v-for="protector in optProtectors2" v-bind:key="protector" v-bind:value="protector">
                                    {{ protector }}
                                </option>
                            </b-form-select>
                        </b-col>
                        <b-col md="8">
                            <b-form-text>Motor No. 4</b-form-text>
                            <b-form-select size="sm" v-model="input.motor4">
                                <option value=0>Do not use</option>
                                <option value=1>
                                    {{ input.motor1[4] }}, {{ input.motor1[1] }} HP, {{ input.motor1[2] }} V, {{ input.motor1[3] }} A
                                </option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="4">
                            <b-form-text>Motor Rated Voltage</b-form-text>
                            <strong>{{ motorRatedVoltage }}</strong> <span style="font-size: 10pt"> Volt @ 60 Hz</span>
                        </b-col>
                        <b-col md="4">
                            <b-form-text>Motor Rated Current</b-form-text>
                            <strong>{{ motorRatedCurrent }}</strong> <span style="font-size: 10pt"> Ampere @ 60 Hz</span>
                        </b-col>
                        <b-col md="4" >
                           
                            <b-form-text>Total Motor Used (Tandem)</b-form-text>
                            <b-input-group size="sm" append="Motor">
                                <b-input size="sm" type="number" step="any" readonly v-model="requiredtotaltandem" />
                            </b-input-group>
                        </b-col>


                        <b-col md="4" class="mt-3">
                            <b-form-text>Minimum Motor Load</b-form-text>
                            <strong>{{ minMotorLoad }}</strong> <span style="font-size: 10pt"> HP</span>
                        </b-col>
                        <b-col md="4" class="mt-3">
                            <b-form-text>Selected Motors' HP</b-form-text>
                            <strong>{{ motorRatedHp }}  <span style="font-size: 10pt"> HP</span>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card class="mt-4">
                    <b-row>
                        <b-col md="10">
                            <h4 class="strong">Power Cable</h4>
                        </b-col>
                        <b-col md="2" style="text-align: end">
                            <b-badge 
                                v-if="input.powerCable[0] == ''"
                                variant="danger" 
                                v-b-popover.hover.right="{ variant: 'danger', content:'No power cable selected.' }">
                                Warning
                            </b-badge>
                        </b-col>
                    </b-row>
                    <hr />
                    <b-alert variant="warning" style="padding: 0.5rem" :show="optPowerCables[0][0] == ''">
                        <b-form-text style="margin: 0; color: black !important">
                            Your current motors' rated current is not eligible for any available power cables. Consider selecting motors with a higher current rating.
                        </b-form-text>
                    </b-alert>
                    <b-row>
                        
                        <b-col md="4">
                            <b-form-text>Voltage Drop</b-form-text>
                            <b-input-group size="sm" append="Volt">
                                <b-input size="sm" type="number" step="any" readonly v-model="voltDropCable" />
                            </b-input-group>
                        </b-col>


                    </b-row>   
                    <b-row>
                        <b-col md="4">
                            <b-form-text>Power Cable</b-form-text>
                            <b-form-select size="sm" v-model="input.powerCable">
                                <option v-for="cable in optPowerCables" v-bind:key="cable[0]" v-bind:value="cable">
                                    {{ cable[0] }}
                                </option>
                            </b-form-select>
                        </b-col>
                        <b-col md="4">
                            <b-form-text>Required Surface Voltage</b-form-text>
                            <b-input-group size="sm" append="Volt">
                                <b-input size="sm" type="number" step="any" readonly v-model="requiredSurfaceVoltage" />
                            </b-input-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-text>Required Surface KVA</b-form-text>
                            <b-input-group size="sm" append="kVA">
                                <b-input size="sm" type="number" step="any" readonly v-model="requiredSurfaceKVA" />
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card class="mt-4">
                    <b-row>
                        <b-col md="10">
                            <h4 class="strong">Trafo</h4>
                        </b-col>
                        <b-col md="2" style="text-align: end">
                            <b-badge 
                                v-if="input.trafoSelectedCapacity < minTrafoCapacity"
                                variant="danger" 
                                v-b-popover.hover.right="{ variant: 'danger', content:'The selected trafo capacity is lower than the minimum trafo capacity!' }">
                                Warning
                            </b-badge>
                        </b-col>
                    </b-row>
                    <hr />
                    <b-row>
                        <b-col md="4"> 
                            <b-form-text>Minimum Capacity</b-form-text>
                            <b-input-group size="sm" append="kVA">
                                <b-input size="sm" type="number" step="any" readonly v-model="minTrafoCapacity" />
                            </b-input-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-text>Selected Capacity</b-form-text>
                            <b-input-group size="sm" append="kVA">
                                <b-input size="sm" type="number" step="any" v-model="input.trafoSelectedCapacity" />
                            </b-input-group>
                        </b-col>

                      <b-col md="4"><!--
                            <b-form-text>Safety Factor</b-form-text>
                            <b-input-group size="sm" append="%">
                                <b-input size="sm" type="number" step="any" v-model="input.trafoSafetyFactor" />
                            </b-input-group> -->
                        </b-col>
                        
                    </b-row>
                </b-card>
                <b-card class="mt-4">
                    <b-row>
                        <b-col md="10">
                            <h4 class="strong">Power Supply</h4>
                        </b-col>
                        <b-col md="2" style="text-align: end">
                            <!-- <b-badge 
                                variant="danger" 
                                v-if="((input.powerSupply == 'Gas Engine' || input.powerSupply == 'Diesel Engine') && input.gasEngineSelectedCapacity < minGasEngineCapacity)"
                                v-b-popover.hover.right="{ variant: 'danger', content:'The selected gas engine capacity is lower than the minimum gas engine capacity!' }">
                                Warning
                            </b-badge> -->
                        </b-col>
                    </b-row>
                    <hr />
                    <b-row>
                        <b-col md="4">
                            <b-form-text>Type</b-form-text>
                            <b-form-select size="sm" v-model="input.powerSupply">
                                <option value="Power Plant">Power Plant</option>
                                <option value="Gas Engine">Gas Engine</option>
                                <option value="Diesel Engine">Diesel Engine</option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row v-if="input.powerSupply != 'Power Plant'" class="mt-2">
                        <b-col md="4">
                            <b-form-text>Efficiency</b-form-text>
                            <b-input-group size="sm" append="%">
                                <b-input size="sm" type="number" step="any" v-model="input.gasEngineEff" />
                            </b-input-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-text>Minimum Capacity</b-form-text>
                            <b-input-group size="sm" append="kVA">
                                <b-input size="sm" type="number" step="any" readonly v-model="minGasEngineCapacity" />
                            </b-input-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-text>Selected Capacity</b-form-text>
                            <b-input-group size="sm" append="kVA">
                                <b-input size="sm" type="text" v-model="input.gasEngineSelectedCapacity" />
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card class="mt-4">
                    <b-row>
                        <b-col md="10">
                            <b-alert variant="warning" style="padding: 0.5rem; margin-bottom: 0; color: black !important" :show="isSavingAllowed">
                                <b-form-text style="margin: 0">
                                    Note: Unresolved warning(s) found.
                                </b-form-text>
                            </b-alert>
                        </b-col>
                        <b-col md="2">
                            <b-btn block variant="primary" @click="didTapSave" :disabled="isSaving">Save</b-btn>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'equipment-selection',
    data() {
        return {

            input: {
                naturalSeparationEff: 20,
                isUsingDownholeSensor: 0,
                gasHandler: "None",
                gasHandlerEff: 70,
                gasSeparator: "Standard BOI 400s",
                gasSeparatorEff: 60,
                protector1: "PFDB 456s",
                motor1: [0, 40, 1340, 19, "456s"],
                motor2: 0,
                motor3: 0,
                motor4: 0,
                totaltandem: 0,
                protector2: "Do not use",
                protector3: "Do not use",
                protector4: "Do not use",
                powerCable: ["", 0, 0],
                trafoSafetyFactor: 98, //Sebelumnya 90
                trafoSelectedCapacity: null,
                gasEngineEff: 80,
                gasEngineSelectedCapacity: null,
                powerSupply: "Power Plant"
            },

            // Variables taken from previous sections
            selectedPump: "",
            pumpType: "",
            stages: 0,
            frequency: 0,
            prctFGAvailable: 0,
            graphHP: 0,
            bht: 0,
            psd: 0,

            // Variable for tracking changes
            lastProtectorType: "456s",
            isInitialized: false, // For power cable matching during creation
            isSaving: false,

            motors117s: [
                // HP, Volt, Amp, Type, test git
                [0, 48, 1070, 25, "PMM-1VEDB-117/3M1V5 3000 RPM"],
               
            ],

            motors319s: [
                // HP, Volt, Amp, Type,
                [0, 97, 1235, 39, "Borets PMM 319s 6000 RPM"]
            ],

            motors456s: [
                // HP, Volt, Amp, Type, test git
                [0, 40, 1340, 19, "456s"],
                [1, 40, 940, 27.5, "456s"],
                [2, 50, 1169, 27.5, "456s"],
                [3, 50, 955, 33, "456s"],
                [4, 60, 970, 39, "456s"],
                [5, 60, 1330, 29, "456s"],
                [6, 70, 1135, 35, "456s"],
                [7, 90, 960, 59, "456s"],
                [8, 100, 1355, 46, "456s"],
                [9, 110, 1190, 60, "456s"],
                [10, 120, 1295, 59, "456s"],
                [11, 40, 672, 35, "PMM-456 PL200 3600 RPM"],
                [12, 60, 1022, 35, "PMM-456 PL200 3600 RPM"],
                [13, 80, 1356, 35, "PMM-456 PL200 3600 RPM"],
                [14, 100, 1698, 35, "PMM-456 PL200 3600 RPM"],
                [15, 120, 2028, 35, "PMM-456 PL200 3600 RPM"],
                [16, 200, 2028, 58, "PMM-456 PL200 3600 RPM"],
                [17, 280, 2830, 57, "PMM-456 PL200 3600 RPM"],
                [18, 70, 1235, 36, "456s"],
                [19, 35, 385, 57, "456s"],
                [20, 40, 430, 59, "456s"],
                [21, 50, 815, 39, "456s"],
                [22, 50, 1125, 28.5, "456s"],
                [23, 80, 1310, 39, "456s"],
                [24, 100, 1150, 55, "456s"],
                [25, 120, 1300, 58, "456s"],
                [26, 35, 385, 57, "456s"],
                [27, 40, 430, 59, "456s"]
            ],

            motors460s: [
                // HP, Volt, Amp
                [0, 57.9, 1284, 25, "Borets PMM 460s 3600 RPM"],
                [1, 101.3, 2244, 25, "Borets PMM 460s 3600 RPM"],
                [2, 144.8, 1920, 41.5, "Borets PMM 460s 3600 RPM"],
                [3, 225.2, 2052, 56, "Borets PMM 460s 3600 RPM"]
            ],

            motors512s: [
                // HP, Volt, Amp
                [0, 80, 1370, 44, "PMM-512 PL200 3600 RPM"],
                [1, 120, 2019, 44, "PMM-512 PL200 3600 RPM"],
                [2, 200, 2846, 50, "PMM-512 PL200 3600 RPM"],
                [3, 280, 3111, 47, "PMM-512 PL200 3600 RPM"]               
            ],

            motors540s: [
                // HP, Volt, Amp
                [0, 60, 870, 45, "540s"],
                [1, 60, 970, 40, "540s"],
                [2, 60, 1330, 29, "540s"],
                [3, 80, 1160, 45, "540s"],
                [4, 120, 1295, 59, "540s"],
                [5, 120, 1070, 70, "540s"],
                [6, 120, 1350, 58.5,"540s"],
                [7, 130, 1125, 67, "540s"],
                [8, 180, 1945, 59, "540s"],
                [9, 225, 2300, 62, "540s"],
                [10, 50, 975, 32, "540s"],
                [11, 225, 2235, 64, "540s"]
            ],

            
             motors562s: [
                // HP, Volt, Amp
                [0, 100, 1148, 45, "PMM-562 PL200 3600 RPM"],
                [1, 150, 1722, 45, "PMM-562 PL200 3600 RPM"],
                [2, 200, 2295, 45, "PMM-562 PL200 3600 RPM"],
                [3, 450, 2555, 90, "PMM-562 PL200 3600 RPM"]               
            ],

            powerCables: [
                // Name, Volt Drop, Current Carrying Capacity
                ["AWG #6", 0.727272727272727, 53],
                ["AWG #5", 0.6, 62],
                ["AWG #4", 0.451612903225806, 71],
                ["AWG #1", 0.23, 110]
            ]

        }
    },
    computed: {

        freeGasIntoPumpLimit() {
            
            if(this.pumpType == "Radial") {
                return 10
            }
                
            return 25
            
        },

        protectors() {

            var protectors = [
                "Borets RU BPBSL 460s",
                "PFDB 456s", 
                "BPBSL 456s", 
                "Borets UN BPBSL 460s", 
                "Borets BPBSL HL-HT 512s" , 
                "PFDB 540s", 
                "66L 540s", 
                "BPBSL 540s", 
                "Borets BPBSL HL-HT 538s 562s",
                "Borets UN BSB 319s",
                "Borets UN BSB (S4 for UT) 319s"
            ]

            if(this.$core.idConstraint < 5.92) {
                protectors = protectors.filter(prot => !prot.endsWith("540s","460s", "512s", "562s"))
            }

            if(this.input.gasSeparator.endsWith("540s")) {
                protectors = protectors.filter(prot => !prot.endsWith("456s","460s", "512s", "562s"))
            }

            return protectors

        },

        optSeparator() {

            var separators = [
                "Standard BOI 400s", 
                "Standard BOI 540s", 
                "Gas Separator 400s", 
                "Gas Separator 540s", 
                "Borets RU GSVB5-250", 
                "Borets UN GSV-400-3000", 
                "Borets UN GSV-272-1250",
                "VGS CW 9000 B538 Borets",
                "Vortex GS 400s",
                "Vortex GS 540s"
            ]

            if(this.$core.idConstraint < 5.92) {
                separators = separators.filter(sepa => !sepa.endsWith("540s", "B538"))
            }

            if(this.input.gasHandler == "None") {

                if(this.selectedPump.startsWith("TG")) {
                    separators = separators.filter(sepa => !sepa.endsWith("400s", "117s", "B400"))
                }
                
            }
            else if(this.input.gasHandler.startsWith("540s")) {
                separators = separators.filter(sepa => !sepa.endsWith("400s"))
            }
            

            return separators

        },

        optHandler() {

            var handlers = [
                "None", 
                "400s WD 100-500", "400s WD 500-1000", "400s WD 1200-2250", "400s WD 2000-3000","400s FL-CT 48 STG 1300-2600", "400s FL-CT 1200-2050",
                "540s WG 800-1500", "540s WG 1000-3000", "540s WG 2500-4500", "540s WG 3000-6000", "B400 Vapro 750 CW", "B400 Vapro 2000 CW"
            ]
            
            if(this.$core.idConstraint < 5.92) {
                handlers = handlers.filter(hand => !hand.startsWith("540s"))
            }

            if(this.selectedPump.startsWith("TG")) {
                handlers = handlers.filter(hand => !hand.startsWith("400s", "B400"))
            }

            return handlers

        },

        prctFGIntoPump() {

            let gh = this.input.gasHandler == "None" ? 0 : this.prct(this.input.gasHandlerEff)
            let gs = !this.input.gasSeparator.startsWith("Standard") ? this.prct(this.input.gasSeparatorEff) : 0

            let prct = this.prct(this.prctFGAvailable) * 
                (1 - this.prct(this.input.naturalSeparationEff)) * 
                (1 - gh) * (1 - gs) * 100

            return this.$helper.roundify(prct)

        },

        minMotorLoad() {
            let handler = this.input.gasHandler == "None" ? 0 : 1
            let separator = this.input.gasSeparator.startsWith("Gas") || this.input.gasSeparator.startsWith("GSV") || this.input.gasSeparator.startsWith("VGS") == "Gas Separator" ? 1 : 0
            let minLoad = ((60 / this.frequency) ** 3) * (handler + separator + +this.graphHP)
            return this.$helper.roundify(minLoad)
        },

        motorRatedHp() {
            let multiplier = this.input.motor2 == 0 ? 1 : 2
            let tandem3 = this.input.motor3 * this.input.motor1[1]
            let tandem4 = this.input.motor4 * this.input.motor1[1]
            return this.input.motor1[1] * multiplier  + tandem3 + tandem4
        },

        motorRatedVoltage() {
            let multiplier = this.input.motor2 == 0 ? 1 : 2
            let tandem3 = this.input.motor3 * this.input.motor1[2]
            let tandem4 = this.input.motor4 * this.input.motor1[2]
            return this.input.motor1[2] * multiplier + tandem3 + tandem4
        },

        motorRatedCurrent() {
            return this.input.motor1[3]
        },

        requiredtotaltandem() {
            let multiplier = this.input.motor2 == 0 ? 1 : 2
            let tandem3 = this.input.motor3 * this.input.motor1[2]
            let tandem4 = this.input.motor4 * this.input.motor1[2]
            return (this.input.motor1[2] * multiplier + tandem3 + tandem4)/this.input.motor1[2]
        },


        voltDropCable() {
            
            let tempCorrection = ( this.bht  * 0.0021) + 0.8423   // (this.bht - 77)) * 2.9
            let voltDrop = this.motorRatedCurrent * this.input.powerCable[1]

            return Math.ceil((this.psd * 3.28084) * voltDrop / 1000 * tempCorrection)  //1.25 ini 2.5 % trafo
                   
        },

        requiredSurfaceVoltage() {
           // return Math.ceil((this.voltDropCable * this.requiredtotaltandem) + this.motorRatedVoltage)
            return Math.ceil((this.motorRatedVoltage + this.voltDropCable)*1.025)
        },

        requiredSurfaceKVA() {
            let kva = this.requiredSurfaceVoltage * this.motorRatedCurrent * Math.sqrt(3) * 1.025 / 1000
            return Math.ceil(kva)
        },

        minTrafoCapacity() {
            return Math.ceil(this.requiredSurfaceKVA / this.prct(this.input.trafoSafetyFactor))
        },

        minGasEngineCapacity() {
            return Math.ceil(this.requiredSurfaceKVA / this.prct(this.input.gasEngineEff))
        },

        optProtectors2() {
            // if(this.input.protector1.endsWith("456s")) {
            //     return ["PFDB 456s", "BPBSL 456s"]
            // }
            //  if(this.input.protector1.endsWith("117s")) {
            //     return ["BPBSL HL-HT 117s"]
            // }
            // if(this.input.protector1.endsWith("512s")) {
            //     return ["BPBSL HL-HT 512s"]
            // }
            // if(this.input.protector1.endsWith("562")) {
            //     return ["BPBSL HL-HT 538s 562s"]
            // }
            // else {
            //     return ["PFDB 540s", "66L 540s", "BPBSL 540s"]
            // }
            return [
                "Borets RU BPBSL 460s",
                "PFDB 456s", 
                "BPBSL 456s", 
                "Borets UN BPBSL 460s", 
                "Borets BPBSL HL-HT 512s" , 
                "PFDB 540s", 
                "66L 540s", 
                "BPBSL 540s", 
                "Borets BPBSL HL-HT 538s 562s",
                "Borets UN BSB 319s",
                "Borets UN BSB (S4 for UT) 319s"
            ]
        },

        optPowerCables() {
            let cables = this.powerCables.filter(item => {
                return this.motorRatedCurrent < item[2]
            })

            if(cables.length == 0) {
                return [["", 0, 0]]
            }
            else {
                if(!cables.includes(this.input.powerCable) && this.isInitialized) {
                    this.input.powerCable = cables[0]
                }

                this.isInitialized = true

                return cables
            }
        },

        isSavingAllowed() {
            return this.prctFGIntoPump > 10 ||
                this.minMotorLoad > this.motorRatedHp ||
                this.input.powerCable[0] == '' ||
                this.input.trafoSelectedCapacity < this.minTrafoCapacity
                // ((this.input.powerSupply == 'Gas Engine' || this.input.powerSupply == 'Diesel Engine') && this.input.gasEngineSelectedCapacity < this.minGasEngineCapacity)
        }

    },
    methods: {

        prct(val) {
            return val / 100
        },

        didChangeFirstProtector() {

            let currentProtectorType = this.input.protector1.slice(-4)

            if(currentProtectorType != this.lastProtectorType) {

                this.input.protector2 = "Do not use"

                if(currentProtectorType == "456s") {
                    this.input.motor1 = [0, 40, 1340, 19, "456s"]
                }
                else {
                    this.input.motor1 = [0, 60, 870, 45, "540s"]
                }

            }

            this.lastProtectorType = currentProtectorType

        },

        didTapSave() {

            // Extra variables for summary
            let extras = {
                minMotorLoad: this.minMotorLoad,
                minMotorLoad60Hz: this.getMinMotorLoadAt60Hz(),
                surfaceVoltage: this.requiredSurfaceVoltage,
                prctFGIntoPump: this.prctFGIntoPump,
                totaltandem: this.requiredtotaltandem
            }

            let input = { ...this.input, ...extras }

            let payload = {
                calculationId: this.$core.id,
                equipment: input
            }

            this.isSaving = true
            this.$axios.post("/calc/saveEquipment", payload).then(response => {

                let res = response.data

                if(res.message == "OK") {

                    this.$helper.toastSuccess(this, "Equipment selection successfully saved!")

                    this.$bvToast.toast("The summary is now available to download. You can download it from the Overview tab.", {
                        title: 'Information - Summary',
                        variant: "info",
                        autoHideDelay: 10000,
                        solid: true
                    })

                    this.$core.equipment = this.input

                }
                else {
                    this.$helper.toastError(this, res.message)
                }

            })
            .catch(() => {
                this.$helper.toastError(this, "Failed to save, please wait a moment and retry!")
            })
            .finally(() => {
                this.isSaving = false
            })

        },

        getMinMotorLoadAt60Hz() {
            let handler = this.input.gasHandler == "None" ? 0 : 10
            let separator = this.input.gasSeparator.startsWith("Gas")  || this.input.gasSeparator.startsWith("GSV") || this.input.gasSeparator.startsWith("VGS") ? 3 : 0
            let minLoad = handler + separator + +this.graphHP + 1 // Kemungkinan bisa berubah +1
            return this.$helper.roundify(minLoad)
        }

    },
    created: function() {

        let pump = this.$core.pump.graph.graph
        this.prctFGAvailable = this.$helper.roundify(this.$core.output.PrctFG)
        this.selectedPump = pump.pump
        this.pumpType = pump.pumpType
        this.stages = pump.stages
        this.frequency = pump.frequency
        this.graphHP = pump.hp
        this.bht = this.$core.input.bht
        this.psd = this.$core.input.psdmd
        
        

        if(this.$core.equipment != null && "motor1" in this.$core.equipment) {
            this.input = this.$core.equipment
        }


    }
}
</script>